export const PartnerDetails={
    AIA: {
        name: 'AIA'
    }
};